/** @format */

import "./Style/App.css";
import React from "react";
import Search from "./components/Search";
import "bootstrap/dist/css/bootstrap.css";

const App = () => {
  return (
    <div>
      <div>
        <Search />
      </div>
    </div>
  );
};
export default App;
